<template lang="pug">
  ul.dropdown
    li.dropdown__item
      a.dropdown__link(
      href=""
      @click.prevent="onClickProfile"
      ) {{translation.header.profile}}
    li.dropdown__item(
      @click.prevent="onLogOut"
    )
      router-link.dropdown__link(
        to="/"
      ) {{translation.header.log_out}}
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { RoleEnums } from "../../const";

export default {
  name: "dropdown",
  computed: {
    ...mapState(["userData", "translation"]),
    role() {
      return this.userData.role;
    },
  },
  methods: {
    ...mapMutations(["removeToken"]),
    onClickProfile() {
      switch (this.role) {
        case RoleEnums.USER:
          this.$router.push({ name: "user-page" });
          return;
        case RoleEnums.OPERATOR:
          this.$router.push({ name: "operator-page" });
          return;
        case RoleEnums.MODERATOR:
          this.$router.push({ name: "operator-page" });
          return;
        case RoleEnums.ADMIN:
          this.$router.push({ name: "admin-page" });
          return;
        default:
          return;
      }
    },
    onLogOut() {
      this.$emit("close");
      this.removeToken();
    },
    onBodyClick() {
      this.$emit("close");
    },
    addClickListener() {
      document.body.addEventListener("click", this.onBodyClick);
    },
    removeClickListenner() {
      document.body.removeEventListener("click", this.onBodyClick);
    },
  },
  created() {
    setTimeout(this.addClickListener, 250);
  },
  beforeDestroy() {
    this.removeClickListenner();
  },
};
</script>
